angular.module('gc.account-popin', ['gc.user'])
.controller("AccountPopinController", [
'$rootScope',
'$scope',
'$element',
'GcUser',
'CommentService',
'APP_LANGUAGES',
function ($rootScope, $scope, $element, GcUser, CommentService, APP_LANGUAGES) {
  'use strict';

  $scope.APP_LANGUAGES = APP_LANGUAGES;
  $scope.CommentService = CommentService;

  function syncAccount() {
    $scope.account = angular.extend({password: ""}, GcUser.getUser());
    $scope.initialAccount = angular.copy($scope.account);
  }

  syncAccount();

  // reload user data once verification done
  $rootScope.$on('user:change', syncAccount);

  $scope.onOverlayClick = function(event) {
    if (event.target.classList.contains('gc-popin-account')) {
      $scope.close();
    }
  };

  $scope.cancelEmailValidation = function (event) {
    event.preventDefault();
    $scope.hideTokenPopin();
    GcUser.cancelEmailValidation();
  };

  $scope.showTokenPopin = function (event) {
    event && event.preventDefault();
    $rootScope.showAskEmailPopin = true;
    $rootScope.askEmailPopinOffsetTop = $element[0].getBoundingClientRect().top;
  };

  $scope.hideTokenPopin = function () {
    $rootScope.showAskEmailPopin = false;
    $rootScope.askEmailPopinOffsetTop = 100; // 100px by default
  };

  $scope.resetPass = function() {
    GcUser.resetPass($scope.account.email).success(function() {
      $scope.resetPassSuccess = true;
    });
  };

  $scope.updateAccount = function () {
    $scope.err = null;
    $scope.resetPassSuccess = false;

    var accountData = angular.extend({}, $scope.account);
    delete accountData.website;

    // we don't edit account's language
    // but profile's language
    delete accountData.language;
    delete accountData.loading_depth;

    // update account
    GcUser.update(accountData, function(err, account) {
      if (err) {
        $scope.err = err;
        return;
      }

      // show email popin directly
      if ($scope.account.email !== $scope.initialAccount.email) {
        $scope.showTokenPopin();
      }

      $scope.emailChanged = false;
      mixpanel.track('account:updated');
    });
  };

  $scope.$watch('account', function() {
    $scope.emailChanged = $scope.account.email !== $scope.initialAccount.email;
    $scope.userNameChanged = $scope.account.username !== $scope.initialAccount.username;
  }, true);

  $scope.close = function() {
    $rootScope.popin.account = false;
  };
}])
.directive('accountPopin', ['$document', '$timeout', function ($document, $timeout) {
  'use strict';
  return {
    scope: {
      show: '@',
    },
    controller: "AccountPopinController",
    templateUrl: 'accountPopin.html',
    link: function ($scope, el, attrs, controller) {

      $timeout(function() {
        $document.on('click.gc-account-popin', function(event) {
          if (el[0].contains(event.target)) return
          $timeout($scope.close);
        });

        $document.on('keyup.gc-account-popin', function(event) {
          if (event.keyCode === 27) { // ESC
            $timeout($scope.close);
          }
        });
      }, 0);

      $scope.$on('$destroy', function() {
        $document.off('click.gc-account-popin');
        $document.off('keyup.gc-account-popin');
      });
    }
  };
}]);

